import request from '@/utils/request'

request.defaults.timeout = 60000;

export function getList (entity, filters = {}, pagination = {}, select = []) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination),
      'x-select': JSON.stringify(select),
    }
  }).then( ret => { ret.data = ret.data.map( el => { el._exists = true; return el} ); return ret } )
}

export function getCount (entity, filters = {}) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1 })
    }
  }).then(ret => ret.tot)
}

export function getDetail (entity, entity_id, headers) {
  return request({
    url: '/' + entity + '/' + entity_id,
    method: 'get',
    headers
  }).then( ret => { ret._exists = true; ret._entity_id = entity_id; return ret })
}

export function get (url, headers = {}) {
  return request({
    url,
    method: 'get',
    headers
  })
}

export function post (url, data) {
  return request({
    url,
    method: 'post',
    data
  })
}

export function put (entity, id, data) {
  const method = 'put'
  const url = '/' + entity + '/' + id
  return request({
    url,
    method,
    data
  })
}

export function upsert (entity, data) {
  request.defaults.timeout = 120000;
  let method = 'post'
  let url = '/' + entity

  if (data._entity_id) {
    method = 'put'
    url = '/' + entity + '/' + data._entity_id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (entity, item) {
  return request({
    url: '/' + entity + '/' + item.id,
    method: 'delete'
  })
}
